import type { RootProps } from 'react-day-picker';

import { cn } from '@/lib/utils';

export type CalendarRootProps = RootProps;

const CalendarRoot = ({ className, rootRef, ...props }: CalendarRootProps) => {
  return <div data-slot="calendar" ref={rootRef} className={cn(className)} {...props} />;
};

export default CalendarRoot;
